<template>
  <!-- :defaultSelectedKeys="activeIndex" -->
  <a-menu
    theme="light"
    mode="inline"
    :open-keys="openKeys"
    :selected-keys="selectedKeys"
    style="text-align: left"
    @openChange="onOpenChange"
  >
    <a-sub-menu v-for="item in menu" :key="item.name">
      <div slot="title" @click="changeRouter_father(item)">
        <a-icon :type="item.meta.icon" />
        <span>{{ item.meta.title }}</span>
      </div>
      <a-menu-item
        v-for="child in item.children"
        :key="child.name"
        @click="changeRouter(child.name, child.path)"
        v-show="child.meta.showMenu"
      >
        {{ child.meta.title }}
      </a-menu-item>
    </a-sub-menu>
  </a-menu>
</template>
<script>
import { asyncRouterMap } from "@/config/router.config.js";

export default {
  name: "SideMenu",
  data() {
    return {
      rootSubmenuKeys: [], // 所有一级菜单
      openKeys: [], // 当前展开的一级菜单
      selectedKeys: [], // 当前选中的二级菜单
      menu: [],
      activeIndex: "",
      R_Right: [],
      current: [],
    };
  },
  created() {
    setTimeout(() => {
      this.current = this.$store.state.menu.current;
      // console.log("this.$store.state.menu.current", this.$store.state);
      if (this.$store.state.user.roles != "") {
        this.R_Right = this.$store.state.user.roles.split(",");
      } else if (sessionStorage.getItem("roles")) {
        this.R_Right = sessionStorage.getItem("roles").split(",");
      }
      this.getMenu(this.current);
    }, 100);
    // 加判断
  },
  watch: {
    // 监听到路由地址的改变
    "$route.name": function (newValue) {
      this.selectedKeys = [newValue];
      this.getMenu(newValue);
      this.onOpenChange(this.openKeys);
    },
    R_Right(newValue) {
      const current = this.$store.state.menu.current;
      this.getMenu(current);
    },
    current(newVal) {
      // console.log(newVal);
      this.getMenu(newVal);
    },
    // 监听vuex的可以显示的左侧菜单栏的信息
    "$store.state.user.roles"(newVal) {
      if (newVal) {
        this.R_Right = newVal.split(",");
      }
    },
    deep: true,
    immediate: true,
  },

  methods: {
    onOpenChange(openKeys) {
      // console.log(openKeys);
      if (openKeys.length != 0) {
        const latestOpenKey = openKeys.find((key) => {
          this.openKeys.indexOf(key) === -1;
        });
        if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
          this.openKeys = openKeys.slice(-1);
        } else {
          this.openKeys = latestOpenKey ? [latestOpenKey] : [];
        }
      } else {
        // this.openKeys = [];
      }
    },
    onRouteChange(name) {
      this.selectedKeys = [name];
    },
    getMenu(current) {
      let pageArrs = [];
      for (let i = 0; i < asyncRouterMap.length; i++) {
        let pageArr = [];
        for (let k = 0; k < asyncRouterMap[i].children.length; k++) {
          if (this.R_Right.indexOf(asyncRouterMap[i].children[k].name) != -1) {
            pageArr.push(asyncRouterMap[i].children[k]);
          }
        }
        // console.log("pageArr", pageArr);
        if (pageArr.length != 0) {
          let pageObject = {};
          pageObject.path = asyncRouterMap[i].path;
          pageObject.name = asyncRouterMap[i].name;
          pageObject.meta = asyncRouterMap[i].meta;
          pageObject.component = asyncRouterMap[i].component;
          pageObject.redirect = asyncRouterMap[i].redirect;
          pageObject.children = pageArr;
          pageArrs.push(pageObject);
        }
      }
      this.menu = pageArrs;
      // console.log("this.menu", this.menu);
      if (localStorage.getItem("path") != null) {
        this.selectedKeys = [localStorage.getItem("path")];
        if (
          localStorage.getItem("path") == "SiteNeat" ||
          localStorage.getItem("path") == "AlarmEvent"
        ) {
          this.openKeys = ["image"]; //销毁
        } else if (localStorage.getItem("path") == "WorkerAttend") {
          this.openKeys = ["Worker"]; //销毁
        } else if (localStorage.getItem("path") == "SiteList") {
          this.openKeys = ["Site"];
        } else if (localStorage.getItem("path") == "DeviceList") {
          this.openKeys = ["device"];
        } else if (localStorage.getItem("path") == "AttendStatistics") {
          this.openKeys = ["dataStatistics"];
        }
      } else if (current) {
        // 有指定菜单，显示指定菜单
        this.selectedKeys.push(current);
        asyncRouterMap.forEach((el) => {
          this.rootSubmenuKeys.push(el.name);
          for (let i = 0; i < el.children.length; i++) {
            if (el.children[i].name === current) {
              // this.openKeys.push(el.name);
              this.openKeys = [el.name];
              // console.log(this.openKeys);
              return;
            }
          }
        });
      } else {
        // 没有指定菜单，默认显示第一个
        let hasOpenKeys = false;
        asyncRouterMap.forEach((el) => {
          this.rootSubmenuKeys.push(el.name);
          if (!hasOpenKeys) {
            this.openKeys.push(el.name);
            // console.log(el.name);
            hasOpenKeys = true;
            // 默认显示第一个二级菜单
            this.selectedKeys.push(el.children[0].name);
          }
        });
      }
    },
    changeRouter(name, path) {
      localStorage.removeItem("path");
      // console.log("this.selectedKeys", this.selectedKeys);
      this.selectedKeys = [name];
      if (name === "DataV") {
        const { href } = this.$router.resolve({ path: "/DataView" });
        window.open(href, "_blank");
      } else if (name === "Patrol") {
        localStorage.removeItem("patrolParam");
        const { href } = this.$router.resolve({ path: "/PatrolView" });
        window.open(href, "_blank");
      } else if (name === "CaseField") {
        const { href } = this.$router.resolve({ path: "/CaseFieldView" });
        window.open(href, "_blank");
      } else if (name === "customPreview") {
        //这个要和菜单栏里的名字一样，不然不会打开新窗口
        const { href } = this.$router.resolve({ path: "/customPreviewView" });
        window.open(href, "_blank");
      } else if (name === "BoardTotal") {
        const { href } = this.$router.resolve({ path: "/BoardTotalView" });
        window.open(href, "_blank");
      } else if (name === "ExhibitionBoard") {
        const { href } = this.$router.resolve({ path: "/ExhibitionBoardView" });
        window.open(href, "_blank");
      } else if (name === "MapFieldboard") {
        const { href } = this.$router.resolve({ path: "/MapFieldboard" });
        window.open(href, "_blank");
      } else if (name === "videoRecord") {
        const { href } = this.$router.resolve({ path: "/VideoRecordView" });
        window.open(href, "_blank");
      }
      // 新增 测试
      else if (name == "Index2x3") {
        localStorage.removeItem("patrolParam");
        const { href } = this.$router.resolve({ path: "/Index2x3" });
        window.open(href, "_blank");
      }
      //截止
      else {
        this.$store.commit("SET_CURRENT", name);
        this.$router.push({ path });
        return;
      }
    },
    // 点击一级菜单，如果一级菜单为数据看板，直接显示数据看板页面
    changeRouter_father(item) {
      // console.log(item);
      if (item.name == "data") {
        localStorage.setItem("path", "DailyMonitor");
        this.$router.push({
          path: "./DailyMonitor",
        });
      } else {
        localStorage.setItem("path", item.children[0].name);
        this.$router.push({
          path: "." + item.children[0].path,
        });
      }
    },
  },

  destroyed() {
    localStorage.removeItem("path");
  },
};
</script>
<style>
.ant-menu {
  background: #eef2f8;
}
.ant-menu-submenu > .ant-menu {
  background: #eef2f8;
}
.ant-menu .ant-menu-item-selected {
  background: linear-gradient(259.32deg, #0395f5 7.93%, #0349fa 92.07%);
  color: #fff;
}
</style>
